export enum JobStatusId {
  Pending = 0,
  Complete = 1,
  InProgress = 2,
}
